/* Galería del producto:
   - deslizar la foto grande hacia la izquierda pasa a la siguiente y hacia la derecha
     a la anterior (en los extremos da la vuelta); un clic suelto no hace nada;
   - las tarjetas de datos acompañan solo a la primera foto: en cualquier otra se recogen.
   Debajo de 750px no interviene: ahí Dawn ya tiene su carrusel con desplazamiento nativo. */
(() => {
  const UMBRAL = 40; // px que hay que arrastrar para cambiar de foto
  const escritorio = window.matchMedia('(min-width: 750px)');

  const montar = (producto) => {
    producto.dataset.galeriaLista = 'true';
    const galeria = producto.querySelector('media-gallery');
    if (!galeria) return;

    const fotos = () => [...galeria.querySelectorAll('.product__media-item')];
    const activa = () => fotos().findIndex((f) => f.classList.contains('is-active'));

    const mostrarFicha = () => {
      producto.classList.toggle('product--fichas-ocultas', activa() > 0);
    };

    const irA = (paso) => {
      const lista = fotos();
      if (lista.length < 2) return;
      const foto = lista[(activa() + paso + lista.length) % lista.length];
      const id = foto.dataset.mediaId;
      // la miniatura es el camino más fiel: dispara todo lo que Dawn hace al cambiar de foto
      const miniatura = galeria.querySelector(`.thumbnail[data-target="${id}"]`);
      if (miniatura) miniatura.click();
      else if (typeof galeria.setActiveMedia === 'function') galeria.setActiveMedia(id, false);
    };

    // arrastre: la foto sigue un poco al puntero y al soltar decide
    let arrastre = null;
    galeria.addEventListener('pointerdown', (e) => {
      if (!escritorio.matches || e.button !== 0) return;
      const foto = e.target.closest('.product__media-item');
      if (!foto || e.target.closest('button, a, deferred-media, product-model')) return;
      arrastre = { foto, x0: e.clientX, id: e.pointerId };
      foto.classList.add('is-arrastrando');
      foto.setPointerCapture(e.pointerId);
    });

    galeria.addEventListener('pointermove', (e) => {
      if (!arrastre || e.pointerId !== arrastre.id) return;
      const dx = e.clientX - arrastre.x0;
      arrastre.foto.style.setProperty('--galeria-dx', `${(dx * 0.35).toFixed(1)}px`);
    });

    const soltar = (e) => {
      if (!arrastre || e.pointerId !== arrastre.id) return;
      const dx = e.clientX - arrastre.x0;
      arrastre.foto.classList.remove('is-arrastrando');
      arrastre.foto.style.removeProperty('--galeria-dx');
      arrastre = null;
      if (Math.abs(dx) >= UMBRAL) irA(dx < 0 ? 1 : -1);
    };
    galeria.addEventListener('pointerup', soltar);
    galeria.addEventListener('pointercancel', soltar);

    // que el navegador no "levante" la imagen como arrastre nativo
    galeria.addEventListener('dragstart', (e) => {
      if (e.target.closest('.product__media-item')) e.preventDefault();
    });

    // cualquier cambio de foto (miniatura, flechas, teclado, variante) pasa por is-active
    new MutationObserver(mostrarFicha).observe(galeria, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
    mostrarFicha();
  };

  const init = () =>
    document.querySelectorAll('.product--con-fichas:not([data-galeria-lista])').forEach(montar);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
